module.exports = __webpack_public_path__ + "static/media/home-service-slider-11.d7f3eb03.jpg";